import React, { useEffect, useState, useRef, useContext } from 'react'
import Header from '../../Components/Header';
import Collapsible from 'react-collapsible';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PlayIcon from '@mui/icons-material/PlayCircle';
import MaterialIcon from '@mui/icons-material/FileCopy';
import EmptyStar from '@mui/icons-material/StarBorderOutlined';
import FilledStar from '@mui/icons-material/Star';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Oval } from 'react-loader-spinner'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Link } from 'react-router-dom';
import Notes from './Components/Notes';
import { useParams } from 'react-router-dom';
import VerifiedIcon from '@mui/icons-material/Verified';
import { api } from '../../api';
import { baseUrl, path } from '../../constants';
import Player from '../../HulluWare/Player';
import { getHours } from '../CourseDetail/CourseDetail';
import { settingsContext } from '../../Context/settingsProvider';
import Materials from './Components/Materials'
import ReactHtmlParser from 'html-react-parser';

export default function Watch() {
    const {id} = useParams()
    const [source, setSource] = useState(null)
    const [subsection, setSubsection] = useState({})
    const [course, setCourse] = useState(null)
    const [tab, setTab] = useState(0)
    const playerRef = useRef()
    const [selectedSection, setSelectedSection] = useState(null)
    const {t} = useContext(settingsContext)

    useEffect(() => {
        window.scrollTo(0,0)
        api.get(path.stream + '/' + id).then(response => {
            let data = response.data
            if(data.success){
                setCourse(data.course)
                let firstSubSection = data.course.sections[0]?.subsections?.at(0)
                setSubsection(firstSubSection)
                setSource({
                    url: baseUrl + firstSubSection.stream,
                    // label: s.type,
                    type: 'application/x-mpegURL',
                    previewThumbnail: firstSubSection.previewThumbnail,
                    thumbnail: firstSubSection.thumbnail,
                    values: firstSubSection.coursesectionId
                })
            }
        })
    }, [])

    const changeStream = (subsection) => {
        setSubsection(subsection)
        setSource({
            url: baseUrl + subsection.stream,
            // label: s.type,
            type: 'application/x-mpegURL',
            previewThumbnail: subsection.previewThumbnail,
            thumbnail: subsection.thumbnail,
            values: subsection.coursesectionId
        })
        if(playerRef.current){
            playerRef.current.restart()
        }
    }
    
  return (
    <div className='w-full flex-1 flex flex-col pt-[60px] bg-[#f2f2f2] overflow-x-hidden'>
        <Header withLogo dark />
        <div className='flex flex-1 max-md:flex-col'>
            <div className='flex flex-col gap-2 p-6 min-w-[60%] max-md:p-2'>
                <div className='rounded-md overflow-hidden w-full'>
                    {source && <Player options={{source}} playerRef={playerRef} />}
                </div>
                <h1 className='text-[25px] text-black font-bold'>{subsection?.name}</h1>
                <h1 className='text-[16px] text-[#00000090] font-bold'>{course?.title}</h1>
                <div className='w-full border-b-[1px] border-b-[#00000030] border-b-solid flex gap-5 items-center'>
                    <p onClick={() => setTab(0)} className='p-3 border-b-black border-b-solid text-black text-[14px] cursor-pointer' style={{
                        borderBottomWidth: tab == 0 ? 2 : 0
                    }}>
                    {t('COURSE_DESCRIPTION')}
                    </p>
                    <p onClick={() => setTab(1)} className='p-3 border-b-black border-b-solid text-black text-[14px] cursor-pointer' style={{
                        borderBottomWidth: tab == 1 ? 2 : 0
                    }}>
                    {t('RATE_COURSE')}
                    </p>
                    <p onClick={() => setTab(2)} className='p-3 border-b-black border-b-solid text-black text-[14px] cursor-pointer' style={{
                        borderBottomWidth: tab == 2 ? 2 : 0
                    }}>
                    {t('NOTES')} ({t('COMING_SOON')})
                    </p>
                </div>
                {tab == 0 ? (
                    <div className='description p-2'>{ReactHtmlParser(course?.description || '')}</div>
                ) : tab == 1 ? <Rate course={course}  setCourse={setCourse} /> : '' }
                <Link to={'/instructor/' + course?.instructor?.id} className='flex gap-2 items-center'>
                    <img className='w-[70px] h-[70px] rounded-full bg-[#e8e8e8] object-cover' src={baseUrl + course?.instructor?.image} />
                    <div className=''>
                        <div className='flex items-center gap-1'>
                            <p className='text-black font-bold text-[18px]'>{`${course?.instructor?.firstName || ''} ${course?.instructor?.lastName || ''}`}</p>
                            <VerifiedIcon style={{color: '#52a4e0', fontSize: 20}}>Filled</VerifiedIcon>
                        </div>
                        <p className='mt-1 text-sm'>{course?.instructor?.courseCount + ' ' + t('COURSES')}</p>
                    </div>
                </Link>
            </div>
            <div className='flex-1 flex flex-col min-w-[40%] p-2'>
            <p className='text-black text[30px] font-bold p-3 pl-0 '>{t('COURSE_CONTENTS')}</p>
            {course?.sections?.sort((a, b) => a.order - b.order)?.map(section => (
                <Collapsible trigger={
                    <div className='rounded-md' style={{backgroundColor: '#dedede', padding: 10, marginTop: 10, display: 'flex', 'justifyContent': 'space-between', 'alignItems': 'center', borderColor: '#00000050'}}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 5
                        }}>
                            <p style={{userSelect: "none", color: 'black', fontSize: 17}}>{section.name}</p>
                            <div style={{display: 'flex', gap: 2, alignItems: 'center'}}>
                                <AccessTimeIcon style={{color: '#000000', fontSize: 13}}>Filled</AccessTimeIcon>
                                <p style={{color: '#000000', fontSize: 12}}>Total time: {getHours(section.subsections, true)}</p>
                            </div>
                            
                        </div>
                        <KeyboardArrowDownIcon style={{fontSize: 25, color: '#000000'}}>Filled</KeyboardArrowDownIcon>
                    </div>
                    } transitionTime={200}>
                        <div className='flex justify-center py-2'>
                            <button onClick={() => setSelectedSection(section.id)} className='bg-main px-4 py-1 font-bold text-white text-sm rounded-xl flex items-center gap-1'>
                                <MaterialIcon style={{fontSize: 20, color: '#ffffff'}}>Filled</MaterialIcon>
                                {t('MATERIALS')}
                            </button>
                        </div>
                        {section.subsections?.sort((a, b) => a.order - b.order)?.map(_subsection => (
                            <div style={{
                                display: 'flex',
                                gap: 10,
                                alignItems: 'center',
                                padding: 10,
                                borderRadius: 10,
                                marginTop: 10,
                                backgroundColor: _subsection?.id == subsection.id ? '#52a4e040' : ''
                            }}>
                                {/* <CheckBoxIcon style={{color: '#000000', fontSize: 16}}>Filled</CheckBoxIcon> */}
                                <img src={baseUrl + _subsection.thumbnail} className='w-[50px] h-[28] object-contain rounded-md' />
                                <div className='flex flex-col gap-1'>
                                    <p style={{color: '#000000', fontSize: 14, lineHeight: 1, fontWeight: 'bold'}}>{_subsection.name}</p>
                                    <div className='flex gap-1 items-center'>
                                        <AccessTimeIcon style={{color: '#000000', fontSize: 13}}>Filled</AccessTimeIcon>
                                        <p className='text-black text-[13px] font-bold'>{(parseInt(_subsection.duration) / 60).toFixed(1)} mins</p>
                                    </div>
                                </div>
                                <button onClick={() => changeStream(_subsection)} className='bg-main px-4 py-1 text-white text-sm rounded-xl ml-auto mr-2 flex items-center gap-1'>
                                    <PlayIcon style={{fontSize: 20, color: '#ffffff'}}>Filled</PlayIcon>
                                    {t('PLAY')}
                                </button>
                            </div>
                        ))}
                            
                    </Collapsible>
            ))}
            
            </div>
        </div>
        {selectedSection && <Materials sectionId={selectedSection} setSelected={setSelectedSection} />}
    </div>
  )
}

function Rate({ course, setCourse }){
    const rating = course.rates[0]?.rating
    const [rate, setRate] = useState(rating?.value || 0)
    const [userRate, setUserRate] = useState(rating)
    const [comment, setComment] = useState(rating?.comment || null)
    const [loading, setLoading] = useState(false)
    const {addNotification} = useContext(settingsContext)

    const submitRate = () => {
        if(!rate) return
        setLoading(true)
        api.post(path.rateCourse, {
            id: course.id,
            value: rate,
            comment
        }).then(response => {
            let data = response.data
            if(data.success){
                addNotification('success', 'Success!')
                setUserRate({
                    value: rate, comment
                })
                setCourse({
                    ...course,
                    rates: [
                        {
                            rating: {value: rate, comment}
                        }
                    ]
                })
            }
        }).finally(() => setLoading(false))
    }

    return (
        <div className='flex flex-col gap-2'>
            {userRate?.value && <p className='text-sm text-black'>Your Rate:</p>}
            <div className='flex gap-2 items-center'>
                {Array(5).fill('').map((k, i) => (
                    <button disabled={userRate?.value} onMouseEnter={() => setRate(i + 1)}>
                        {
                            (i + 1) <= rate ? (
                                <FilledStar style={{
                                    color: '#52a4e0'
                                }}>Filled</FilledStar>
                            ) : (
                                <EmptyStar style={{
                                    color: '#000000'
                                }}>Filled</EmptyStar>
                            )
                        }
                    </button>
                ))}
            </div>
            <textarea disabled={userRate?.value} onChange={e => setComment(e.target.value)} value={comment} placeholder='Comment (Optional)' cols='2' rows='2' className='border-[1px] border-[#00000070] p-2 rounded-md'>
            </textarea>
            {!userRate?.value && <button onClick={submitRate} disabled={loading} className='flex items-center justify-center bg-main px-4 py-3 font-bold text-md text-white rounded-md'>
                {loading ? (
                    <Oval
                    visible={true}
                    height="30"
                    width="30"
                    color="#ffffff"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                    />
                ) : `Rate (${rate})` }
            </button> }
        </div>
    )
}